import React from 'react';
import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const EditIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    className={makeClassName('EditIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
  >
    <path
      d="M2,23c-0.26,0-0.52-0.1-0.71-0.29c-0.25-0.25-0.35-0.62-0.26-0.97l1.5-5.5c0.05-0.17,0.13-0.32,0.26-0.44l13.5-13.5
	c1.49-1.49,3.92-1.49,5.41,0c1.49,1.49,1.49,3.92,0,5.41l-13.5,13.5c-0.12,0.12-0.28,0.21-0.44,0.26l-5.5,1.5
	C2.18,22.99,2.09,23,2,23z M4.4,17.02l-0.97,3.56l3.56-0.97L20.29,6.29c0.71-0.71,0.71-1.87,0-2.59s-1.87-0.71-2.59,0L4.4,17.02z
	 M7.5,20.5L7.5,20.5L7.5,20.5z"
    />
  </svg>
);

export default EditIcon;
